import React,{Component} from "react"
import './index.css';

class ExchangeBoard extends Component{

  constructor(props){
    super(props)
  }

  render(){
    return(
        <div class="card text-center exchangeBox">
          <div class="card-header ">
            Featured
          </div>
          <div class="displayInline">
          <div class="card-body">
            <h5 class="card-title text1">{this.props.firstCurrency}</h5>
            <p class="card-text text2">{this.props.firstVal}</p>
            <a href="#" class="btn btn-primary">BUY/SELL</a>
          </div>
          </div>
          <div class="displayInline">
          <div class="card-body">
            <h5 class="card-title text1">{this.props.secondCurrency}</h5>
            <p class="card-text text2">{this.props.secondVal}</p>
            <a href="#" class="btn btn-primary">BUY/SELL</a>
          </div>
          </div>
        </div>

    )
  }
}
export default ExchangeBoard
